import _classCallCheck from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _isNativeReflectConstruct from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/isNativeReflectConstruct";
import _getPrototypeOf from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
import './index.css';
import React from 'react';
// @ts-ignore

import ReactPlayerLoader from '@brightcove/react-player-loader';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import ReactDOM from 'react-dom';
import { ReactComponent as IconPlay } from '../../resources/icons/ic-play-white.svg';
import { ReactComponent as IconPause } from '../../resources/icons/IconPauseAudio.svg';
import { ReactComponent as IconClose } from '../../resources/icons/close-white.svg';
import { canUseDOM, get } from '../../utils';
import Playlist, { toHHMMSS } from '../BrightcoveVideosAtoms/Playlist';
import { playlistStyles, playlistCssRtl } from '../BrightcoveVideoDetailsHeader';
import VolumeControl from '../BrightcoveVideosAtoms/VolumeControl';
import LazyPicture from '../atoms/LazyPicture';
import { ReactComponent as IconPlaylist } from '../../resources/icons/IconPlaylist.svg';
import { ReactComponent as IconPlaylistHover } from '../../resources/icons/IconPlaylistHover.svg';
import { ReactComponent as IconPlaylistMobile } from '../../resources/icons/IconPlaylistMobile.svg';
import { ReactComponent as IconPlaylistMobileHover } from '../../resources/icons/IconPlaylistMobileHover.svg';
import RouterLink from '../atoms/RouterLink';
import { withRouter } from 'react-router-dom';
var rewindTime = 10;
var ControllPanel = /*#__PURE__*/function (_React$Component) {
  function ControllPanel(props) {
    var _this;
    _classCallCheck(this, ControllPanel);
    _this = _callSuper(this, ControllPanel, [props]);
    _this.playClick = function () {
      _this.props.playPauseClick(!_this.props.isPlay);
    };
    _this.closeDropdwn = function (event) {
      if (event.target.closest) {
        if (!event.target.closest('.playlistControl') && _this.state.openPlaylist) {
          _this.setState({
            openPlaylist: false
          });
        }
      }
    };
    _this.state = {
      openPlaylist: false
    };
    document.body.addEventListener('click onTouchStart', _this.closeDropdwn);
    return _this;
  }
  _inherits(ControllPanel, _React$Component);
  return _createClass(ControllPanel, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        player = _this$props.player,
        volume = _this$props.volume,
        setVolume = _this$props.setVolume,
        playListData = _this$props.playListData,
        rtl = _this$props.rtl,
        _this$props$showSubBu = _this$props.showSubButton,
        showSubButton = _this$props$showSubBu === void 0 ? false : _this$props$showSubBu;
      var isMobile = canUseDOM ? window.matchMedia("(max-width: 992px)").matches : false;
      return /*#__PURE__*/React.createElement("div", {
        className: "contollRow"
      }, /*#__PURE__*/React.createElement(VolumeControl, {
        setVolume: setVolume,
        volume: volume
      }), /*#__PURE__*/React.createElement("div", {
        className: "controllPanel "
      }, /*#__PURE__*/React.createElement("div", {
        className: "controllPanel__playButton  ".concat(showSubButton ? 'show-sub-btn' : ''),
        onClick: function onClick() {
          _this2.playClick();
        }
      }, !player.paused() ? /*#__PURE__*/React.createElement(IconPause, null) : /*#__PURE__*/React.createElement(IconPlay, null))), playListData && playListData.season.length ? /*#__PURE__*/React.createElement("div", {
        className: "playlistControl ".concat(this.state.openPlaylist ? 'isOpen' : ''),
        onMouseEnter: function onMouseEnter() {
          return !isMobile && _this2.setState({
            openPlaylist: !_this2.state.openPlaylist
          });
        },
        onMouseLeave: function onMouseLeave() {
          return !isMobile && _this2.setState({
            openPlaylist: !_this2.state.openPlaylist
          });
        }
      }, this.state.openPlaylist && /*#__PURE__*/React.createElement(Playlist, {
        episodesText: playListData.episodesText,
        styles: "".concat(playlistStyles, " ").concat(playlistPlayerStyles, " ").concat(rtl ? playlistCssRtl + ' ' + playlistPlayerStylesRtl : ''),
        itemId: playListData.itemId,
        season: playListData.season
      }), isMobile ? /*#__PURE__*/React.createElement(IconPlaylistMobile, {
        className: 'playlist-icon playlist-icon--mobile',
        onClick: function onClick() {
          return isMobile && _this2.setState({
            openPlaylist: !_this2.state.openPlaylist
          });
        }
      }) : /*#__PURE__*/React.createElement(IconPlaylist, {
        className: 'playlist-icon'
      }), isMobile ? /*#__PURE__*/React.createElement(IconPlaylistMobileHover, {
        className: 'playlist-icon-hover playlist-icon-hover--mobile',
        onClick: function onClick() {
          return isMobile && _this2.setState({
            openPlaylist: !_this2.state.openPlaylist
          });
        }
      }) : /*#__PURE__*/React.createElement(IconPlaylistHover, {
        className: 'playlist-icon-hover'
      })) : '');
    }
  }]);
}(React.Component);
var NextVideos = /*#__PURE__*/function (_React$Component2) {
  function NextVideos(props) {
    var _this3;
    _classCallCheck(this, NextVideos);
    _this3 = _callSuper(this, NextVideos, [props]);
    _this3.primary = void 0;
    _this3.primary = 'var(--main-color-text)';
    _this3.state = {
      show: true
    };
    return _this3;
  }
  _inherits(NextVideos, _React$Component2);
  return _createClass(NextVideos, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        _this$props2$hideNext = _this$props2.hideNextLink,
        hideNextLink = _this$props2$hideNext === void 0 ? function () {} : _this$props2$hideNext,
        title = _this$props2.title,
        _this$props2$duration = _this$props2.duration,
        duration = _this$props2$duration === void 0 ? 10 : _this$props2$duration,
        player = _this$props2.player,
        remainingTime = _this$props2.remainingTime;
      var video,
        fallbackImage = '',
        url,
        timestamp,
        fallbackImageUrl,
        Duration,
        titleValue;
      if (this.props.nextVideoData && Object.keys(this.props.nextVideoData).length) {
        video = this.props.nextVideoData.video;
        fallbackImage = this.props.nextVideoData.fallbackImage;
        url = this.props.nextVideoData.url;
        fallbackImageUrl = get(fallbackImage, 'jss.value.src') || '';
      } else if (this.props.nextVideoSeriesGlobal && Object.keys(this.props.nextVideoSeriesGlobal).length) {
        video = this.props.nextVideoSeriesGlobal.video;
        fallbackImage = this.props.nextVideoSeriesGlobal.fallbackImage;
        url = this.props.nextVideoSeriesGlobal.url;
        fallbackImageUrl = get(fallbackImage, 'jss.value.src') || '';
      }
      var fullTime = duration / 1000 < 10 ? duration / 1000 : 10;
      titleValue = title;
      return /*#__PURE__*/React.createElement(RouterLink, {
        onClick: function onClick() {
          hideNextLink(false);
        },
        openInSameTab: true,
        href: url + '?play=true',
        className: "next-link"
      }, /*#__PURE__*/React.createElement("div", {
        className: 'next-link--fill',
        style: {
          width: "".concat(100 - remainingTime / fullTime * 100, "%")
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: 'next-link__image'
      }, /*#__PURE__*/React.createElement(LazyPicture, {
        useEmptyPlaceholder: true,
        hover: false
      }, /*#__PURE__*/React.createElement("source", {
        srcSet: fallbackImageUrl
      }), /*#__PURE__*/React.createElement("img", {
        src: fallbackImageUrl,
        "aria-hidden": "true"
      }))), /*#__PURE__*/React.createElement("div", {
        className: 'next-link__panel'
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "14",
        viewBox: "0 0 12 14"
      }, /*#__PURE__*/React.createElement("path", {
        "data-name": "Path 66",
        d: "M24.117,32.374V23.626L31.177,28ZM33.576,27.3l-9.882-6.123A1.193,1.193,0,0,0,23.063,21,.983.983,0,0,0,22,21.876V34.124A.983.983,0,0,0,23.063,35a1.19,1.19,0,0,0,.631-.177L33.576,28.7A.79.79,0,0,0,33.576,27.3Z",
        transform: "translate(-22 -21)",
        fill: this.primary
      })), /*#__PURE__*/React.createElement("p", {
        className: 'next-link__title',
        style: {
          color: this.primary
        }
      }, titleValue)));
    }
  }]);
}(React.Component);
var BrightcoveVideoPlayerwithRouter = /*#__PURE__*/function (_React$Component3) {
  function BrightcoveVideoPlayerwithRouter(props) {
    var _this4;
    _classCallCheck(this, BrightcoveVideoPlayerwithRouter);
    _this4 = _callSuper(this, BrightcoveVideoPlayerwithRouter, [props]);
    _this4.videoRef = void 0;
    _this4.rewindFunction = function (evt, data, player) {
      var newTime,
        rewindAmt = data.amount,
        isNext = data.isNext,
        videoCurentTime = player && player.currentTime(),
        videoFullTime = player.duration();
      if (!isNext) {
        if (videoCurentTime >= rewindAmt) {
          newTime = videoCurentTime - rewindAmt;
        } else {
          newTime = 0;
        }
      } else {
        if (videoFullTime - videoCurentTime >= rewindAmt) {
          newTime = videoCurentTime + rewindAmt;
        } else {
          newTime = videoFullTime;
        }
      }
      player && player.currentTime(newTime);
    };
    _this4.checkPlayVideo = function () {
      if (_this4.videoRef.current && _this4.state.player && _this4.state.pause) {
        var visiblePlayer = _this4.checkVisible(_this4.videoRef.current, 200);
        if (visiblePlayer && !_this4.state.play) {
          var propVolume = _this4.props.volume || 0;
          // @ts-ignore
          _this4.state.player.volume(_this4.props.isPreview ? propVolume / 100 : _this4.state.volume / 100);
          // @ts-ignore
          _this4.props.isPreview && _this4.setState({
            volume: propVolume
          });
          _this4.props.isPreview && _this4.state.player.muted(_this4.props.volume ? false : true);
          var self = _this4;
          var promise = _this4.state.player.play();
          if (promise !== undefined) {
            promise.then(function () {});
            promise.catch(function (error) {
              self.state.player.muted(true);
              self.state.player.playsinline(true);
              self.state.player.volume(0);
              self.setState({
                volume: 0
              });
              self.state.player.play();
            });
          }
          _this4.setState({
            play: true
          });
        } else if (!visiblePlayer && _this4.state.play) {
          _this4.state.player.pause({
            which: 'sss'
          });
        }
      }
    };
    _this4.checkVisible = function (elm) {
      var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var mode = arguments.length > 2 ? arguments[2] : undefined;
      threshold = threshold || 0;
      mode = mode || 'visible';
      var rect = elm.getBoundingClientRect();
      var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      var above = rect.bottom - threshold < 0;
      var below = rect.top - viewHeight + threshold >= 0;
      return mode === 'above' ? above : mode === 'below' ? below : !above && !below;
    };
    _this4.addRewindClick = function (player) {
      player.on('rewind', function (evt, data) {
        return _this4.rewindFunction(evt, data, player);
      });
    };
    _this4.changeVideoDuration = function (player) {
      var sp1 = document.createElement('div');
      var sp2 = document.getElementsByClassName('vjs-fullscreen-control')[0];
      sp1.className = 'controllPanel__time';
      player.on('timeupdate', function () {
        var time = toHHMMSS(player.remainingTime());
        sp1.innerText = "-".concat(time);
        document.getElementsByClassName('vjs-control-bar')[0].insertBefore(sp1, sp2);
        if (document.getElementsByClassName('video-time') && document.getElementsByClassName('video-time').length) document.getElementsByClassName('video-time')[0].textContent = "-".concat(time);
      });
    };
    _this4.setVolume = function (value) {
      _this4.setState({
        volume: value
      });
      if (_this4.state.player) {
        _this4.state.player.muted(value ? false : true);
        _this4.state.player.volume(value / 100);
      }
    };
    _this4.startTimer = function () {
      if (!_this4.state.timerId) {
        var timerId = setInterval(function () {
          if (_this4.state.interval == 3) {
            clearInterval(_this4.state.timerId);
            _this4.setState({
              interval: 1,
              showcontrolPanel: false,
              timerId: null
            });
          } else {
            var timer = _this4.state.interval + 1;
            _this4.setState({
              interval: timer,
              timerId: timerId
            });
          }
        }, 1000);
      }
    };
    _this4.changeVideoTimestamp = function (player, videoId) {
      var setVideoTimestamp = _this4.props.setVideoTimestamp;
      _this4.setState({
        timestampInterval: setInterval(function () {
          setVideoTimestamp && setVideoTimestamp(videoId, player.currentTime());
        }, 3000)
      });
    };
    _this4.stopTimerMobile = function () {
      clearTimeout(_this4.state.timeout);
      var timeout = null;
      timeout = setTimeout(function () {
        //this.state.player.controlBar.hide();
        if (!_this4.state.showNextLink) _this4.setState({
          showcontrolPanel: false,
          timeout: null
        });
      }, 3000);
      _this4.setState({
        showcontrolPanel: true,
        timeout: timeout
      });
    };
    _this4.hidePanel = function () {
      if (!_this4.state.showNextLink) {
        _this4.setState({
          showcontrolPanel: false,
          timeout: null
        });
      } else {
        _this4.setState({
          showcontrolPanel: true,
          timeout: null
        });
      }
    };
    _this4.stopTimer = function (e) {
      var _self = _this4;
      clearTimeout(_this4.state.timeout);
      if (e.target.classList.contains('vjs-control-bar') || e.target.closest('.vjs-control-bar') !== null) {
        //this.state.player.controlBar.show();

        _this4.setState({
          showcontrolPanel: true,
          timeout: null
        });
      } else {
        var timeout = null;
        timeout = setTimeout(_self.hidePanel, 3000);

        //this.state.player.controlBar.show();
        _this4.setState({
          showcontrolPanel: true,
          timeout: timeout
        });
      }
    };
    _this4.hideNextLink = function (val) {
      // this.setState({
      //   showNextLink: val,
      // });
    };
    _this4.videoRef = /*#__PURE__*/React.createRef();
    _this4.state = {
      play: true,
      pause: true,
      player: null,
      showcontrolPanel: true,
      showNextLink: false,
      interval: 1,
      timerId: null,
      timeout: null,
      volume: 0,
      timestampInterval: null,
      firstLoad: true,
      fullscreen: false,
      showSubButton: false,
      remainingTime: 10
    };
    _this4.playPauseFunction = _this4.playPauseFunction.bind(_this4);
    return _this4;
  }
  _inherits(BrightcoveVideoPlayerwithRouter, _React$Component3);
  return _createClass(BrightcoveVideoPlayerwithRouter, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.videoId != this.props.videoId && this.state.showNextLink) {
        this.setState({
          showNextLink: false,
          timestampInterval: null
        });
      }
      if (typeof this.props.volume !== 'undefined' && this.props.volume !== prevProps.volume) {
        if (this.state.player) {
          this.state.player.muted(this.props.volume ? false : true);
          this.state.player.volume(this.props.volume / 100);
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _self = this;
      if (canUseDOM) {
        window.addEventListener('scroll', this.checkPlayVideo);
        !this.state.showNextLink && window.addEventListener('mousemove', function (e) {
          _self.stopTimer(e);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.state.timestampInterval);
    }
  }, {
    key: "playPauseFunction",
    value: function playPauseFunction(player, value) {
      this.setState({
        pause: value
      });
      player.paused() ? player.play() : player.pause();
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      /*eslint-disable */
      var _this$props3 = this.props,
        history = _this$props3.history,
        isPreview = _this$props3.isPreview,
        endVideoHandler = _this$props3.endVideoHandler,
        _this$props3$volume = _this$props3.volume,
        volume = _this$props3$volume === void 0 ? 0 : _this$props3$volume,
        title = _this$props3.title,
        rtl = _this$props3.rtl,
        videoSetting = _this$props3.videoSetting,
        setVideoTimestamp = _this$props3.setVideoTimestamp,
        _this$props3$playList = _this$props3.playListObject,
        playListObject = _this$props3$playList === void 0 ? null : _this$props3$playList,
        _this$props3$changeVo = _this$props3.changeVolumeFunc,
        changeVolumeFunc = _this$props3$changeVo === void 0 ? function (e) {} : _this$props3$changeVo;
      var timestamp = videoSetting ? videoSetting.timestamp : 0;
      var _this$state = this.state,
        player = _this$state.player,
        showcontrolPanel = _this$state.showcontrolPanel;
      var spacer = canUseDOM ? document.getElementsByClassName('vjs-spacer')[0] : null;
      var playerContainer = canUseDOM ? document.getElementsByClassName('video-js')[0] : null;
      var isMobile = canUseDOM ? window.matchMedia("(max-width: 992px)").matches : false;
      var _self = this;
      var nextVideoLabel = playListObject && get(playListObject, 'nextVideoLabel') || '';
      var nextVideoSeriesGlobal = playListObject && get(playListObject, 'nextLinkGlobal') || null;
      var nextVideoSeries = null;
      var currentVideoSeries = {};
      var currentVideoEpisodesNumber = 0;
      var currentVideoEpisodesName = playListObject && get(playListObject, 'name') || '';
      if (playListObject) {
        var index = null;
        currentVideoSeries = playListObject.season && playListObject.season.find(function () {
          var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            episode: []
          };
          return s.episode.find(function (s2, i) {
            if (s2.id == playListObject.itemId) {
              currentVideoEpisodesNumber = i + 1;
            }
            return s2.id == playListObject.itemId;
          });
        });
        if (!nextVideoSeriesGlobal && playListObject.season) playListObject.season.some(function () {
          var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            episode: []
          };
          var i1 = arguments.length > 1 ? arguments[1] : undefined;
          return s.episode.find(function (s2, i2) {
            if (s2.id == playListObject.itemId) {
              if (i2 + 1 < s.episode.length) index = {
                i1: i1,
                i2: i2 + 1
              };else if (i1 + 1 < playListObject.season.length) {
                index = {
                  i1: i1 + 1,
                  i2: 0
                };
              }
            }
          });
        });
        if (index) {
          // @ts-ignore
          nextVideoSeries = playListObject.season[index.i1].episode[index.i2];
        }
      }
      var fullTitle = playListObject && currentVideoSeries ? "<span class=\"medium\">".concat(currentVideoEpisodesName, "</span><span>").concat(playListObject.episodeText, " ").concat(currentVideoEpisodesNumber, "</span><span class=\"video-title\">").concat(title, "</span> <span class=\"video-time\"></span>") : "<span class=\"video-title\">".concat(title, "</span> <span class=\"video-time\"></span>");
      return /*#__PURE__*/React.createElement(StyledWrapper, {
        rtl: rtl,
        isPreview: isPreview
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.videoRef,
        onClick: function onClick(event) {
          isMobile && _this5.stopTimerMobile();
        },
        onMouseMove: function onMouseMove(e) {
          //	!isMobile && _self.stopTimer(e);
        },
        onMouseEnter: function onMouseEnter(e) {
          //	!isMobile && _self.stopTimer(e)
        },
        onMouseLeave: function onMouseLeave(e) {
          //	!isMobile && _self.stopTimer(e)
        },
        className: showcontrolPanel ? 'show' : 'hide'
      }, !isPreview && /*#__PURE__*/React.createElement("div", {
        tabIndex: 0,
        className: "close",
        onClick: this.props.closeVideo,
        onKeyPress: function onKeyPress(e) {
          if (e.which === 13 || e.which === 32) {
            e.preventDefault();
            _this5.props.closeVideo();
          }
        }
      }, /*#__PURE__*/React.createElement(IconClose, null)), playerContainer && player && !isPreview && this.state.showNextLink && (nextVideoSeries || nextVideoSeriesGlobal) && /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(NextVideos, {
        hideNextLink: this.hideNextLink,
        nextVideoData: nextVideoSeries,
        nextVideoSeriesGlobal: nextVideoSeriesGlobal,
        title: nextVideoLabel,
        duration: this.props.duration,
        player: this.state.player,
        remainingTime: this.state.remainingTime,
        themesOfPage: this.props.themesOfPage
      }), playerContainer), spacer && player && /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(ControllPanel, {
        nextPrevClick: function nextPrevClick(isNext) {
          player.trigger('rewind', {
            'amount': rewindTime,
            'isNext': isNext
          });
        },
        playPauseClick: function playPauseClick(value) {
          _this5.playPauseFunction(player, value);
        },
        isPlay: !player.paused(),
        player: player,
        setVolume: this.setVolume,
        volume: this.state.volume,
        playListData: playListObject,
        rtl: rtl,
        showSubButton: this.state.showSubButton
      }), spacer), /*#__PURE__*/React.createElement(ReactPlayerLoader, {
        className: commonStyles,
        accountId: this.props.accountId,
        videoId: this.props.videoId,
        options: {
          autoplay: true,
          loop: this.props.loop,
          muted: 'muted'
        },
        title: fullTitle,
        attrs: {
          muted: 'muted',
          autoplay: true,
          playsinline: true,
          playsInline: true
        },
        onSuccess: function onSuccess(success) {
          var myPlayer = success.ref;
          _this5.setState({
            player: success.ref
          });
          var _self = _this5;
          _this5.addRewindClick(myPlayer);
          _this5.changeVideoDuration(myPlayer);
          setVideoTimestamp && _this5.changeVideoTimestamp(myPlayer, _self.props.videoId);
          myPlayer.on('pause', function (e, i, a) {
            _self.setState({
              play: false
            });
          });
          myPlayer.on('play', function () {
            _self.setState({
              play: true
            });
            // if(_self.state.showNextLink) {
            //   if (typeof myPlayer.duration() !== 'number') {
            //     return;
            //   }
            //
            //   let time;
            //   if (myPlayer.ended()) {
            //     time = 0;
            //   }  else if (myPlayer.remainingTimeDisplay) {
            //     time = myPlayer.remainingTimeDisplay();
            //   } else {
            //     time = myPlayer.remainingTime();
            //   }
            //   if (time <= 10 && time >= 0) {
            //     _self.setState({
            //       remainingTime : time
            //     })
            //   }
            // }
          });
          //!isPreview  && myPlayer.enterFullWindow();
          myPlayer.on('volumechange', function (evt) {
            var value = myPlayer.volume() * 100;
            _self.setState({
              volume: value
            });
          });
          myPlayer.on('fullscreenchange', function (evt) {
            _self.setState({
              fullscreen: myPlayer.isFullscreen()
            });
            if (isMobile) {
              myPlayer.play();
            }
          });
          (nextVideoSeries || nextVideoSeriesGlobal) && myPlayer.on('timeupdate', function (e, i) {
            if (!isPreview) {
              if (typeof myPlayer.duration() !== 'number') {
                return;
              }
              var time;

              // @deprecated We should only use remainingTimeDisplay
              // as of video.js 7
              if (myPlayer.ended()) {
                if (nextVideoSeries && nextVideoSeries.url || nextVideoSeriesGlobal && nextVideoSeriesGlobal.url) {
                  myPlayer.clearInterval(_self.state.timestampInterval);
                  _self.setState({
                    showNextLink: false,
                    showcontrolPanel: false,
                    timestampInterval: null
                  });
                  history.push(nextVideoSeries && nextVideoSeries.url + '?play=true&debug=true' || nextVideoSeriesGlobal && nextVideoSeriesGlobal.url + '?play=true&debug=true');
                }
                time = 0;
              } else if (myPlayer.remainingTimeDisplay) {
                time = myPlayer.remainingTimeDisplay();
              } else {
                time = myPlayer.remainingTime();
              }
              if (time <= 10 && time >= 0) {
                _self.setState({
                  remainingTime: myPlayer.duration() - myPlayer.currentTime()
                });
                if (!_self.state.showNextLink) {
                  clearTimeout(_self.state.timeout);
                  clearTimeout(_self.state.timerId);
                  _self.setState({
                    showNextLink: true,
                    showcontrolPanel: true,
                    timeout: null,
                    timerId: null,
                    interval: 0
                  });
                }
              }
              if (time > 10) {
                if (_self.state.showNextLink) {
                  _self.setState({
                    showNextLink: false
                  });
                }
              }
            }
          });
          myPlayer.on('loadeddata', function (e) {
            if (myPlayer.controlBar.subsCapsButton.el_.classList.contains('vjs-hidden')) _self.setState({
              showSubButton: true
            });else _self.setState({
              showSubButton: false
            });
            var iOS = !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent);
            if (!isPreview) {
              if (playListObject && playListObject.season.length) {
                if (_self.state.firstLoad) {
                  !_self.state.fullscreen && myPlayer.requestFullscreen().catch(function () {
                    myPlayer.requestFullscreen();
                  });
                } else if (_self.state.fullscreen) {
                  _self.state.fullscreen && myPlayer.requestFullscreen().catch(function () {
                    myPlayer.requestFullscreen();
                  });
                }
                iOS && myPlayer.play();
                _self.state.firstLoad && _self.setState({
                  firstLoad: false
                });
              } else if (!isPreview && iOS) {
                !isPreview && myPlayer.requestFullscreen();
                myPlayer.play();
              } else {
                myPlayer.requestFullscreen();
              }
            }
            if (!isPreview && iOS) {
              !isPreview && myPlayer.requestFullscreen();
              myPlayer.play();
            }
            isPreview && _self.checkPlayVideo();
          });
          myPlayer.on('loadedmetadata', function () {
            _self.setState({
              showNextLink: false
            });
            timestamp && videoSetting.videoId == _self.props.videoId && myPlayer.currentTime(timestamp);
            myPlayer.playsinline(true);
            myPlayer.muted(volume ? false : true);
            _self.setVolume(volume);
            myPlayer.volume(volume ? volume / 100 : 0);
            var promise = myPlayer.play();
            if (isMobile) {
              _self.stopTimerMobile();
            }
            if (promise !== undefined) {
              promise.then(function () {
                if (!isPreview) {
                  if (playListObject && playListObject.season.length) {
                    if (_self.state.firstLoad) {
                      !_self.state.fullscreen && myPlayer.requestFullscreen().catch(function () {
                        myPlayer.requestFullscreen();
                      });
                    } else if (_self.state.fullscreen) {
                      _self.state.fullscreen && !myPlayer.isFullscreen() && myPlayer.requestFullscreen().catch(function () {
                        myPlayer.requestFullscreen();
                      });
                    }
                    _self.state.firstLoad && _self.setState({
                      firstLoad: false
                    });
                  } else {
                    myPlayer.requestFullscreen();
                  }
                }
                if (isMobile) {
                  myPlayer.on(['click', 'tap', 'touchend'], function () {
                    _self.stopTimerMobile();
                  });
                }
              }).catch(function (error) {
                myPlayer.muted(true);
                myPlayer.playsinline(true);
                myPlayer.volume(0);
                changeVolumeFunc(0);
                myPlayer.play();
                if (isMobile) {
                  myPlayer.on(['click', 'tap', 'touchend'], function () {
                    _self.stopTimerMobile();
                  });
                }
              });
            }
            if (title) {
              document.getElementsByClassName('vjs-dock-title')[0].innerHTML = fullTitle;
            }
          });
          myPlayer.on('ended', function () {
            if (endVideoHandler) endVideoHandler(true);
          });
        }
      })));
    }
  }]);
}(React.Component);
export var BrightcoveVideoPlayer = withRouter(BrightcoveVideoPlayerwithRouter);
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl,
    isPreview = _ref.isPreview;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    fullWidth: true,
    minHeight: true,
    className: "".concat(isPreview ? isPreviewStyles : fullVideoStyles, " ").concat(nextVideosStyles, " ").concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    componentTabIndex: "disabled"
  }, children);
};
// @ts-ignore

var playlistPlayerStyles = "p1jbfyav";
var playlistPlayerStylesRtl = "p12rzvz4";
var nextVideosStyles = "n7dtyel";
var fullVideoStyles = "f1996nms";
var isPreviewStyles = "i5bgjxo";
var commonStyles = "c12df78q";
var rtlStyles = "r1fhoqwc";
var ltrStyles = "l1jazdvl";